module.exports = __webpack_public_path__ + "img/ban.1574b1e5.svg";